export enum CardStatus {
  New = 1,
  Active,
  Blocked,
  Returned,
  InDelivery,
  Arrived,
  Reserved,
}
